import { render, staticRenderFns } from "./fieldTextArea.vue?vue&type=template&id=18566b12&lang=pug&"
import script from "./fieldTextArea.vue?vue&type=script&lang=js&"
export * from "./fieldTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports